"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _platform = _interopRequireDefault(require("./platform"));
var _versions = _interopRequireDefault(require("./versions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// export an object accessed like info.platform.OS, info.version.uds, etc
var _default = exports.default = {
  platform: _platform.default,
  versions: _versions.default
};